import PropTypes from 'prop-types';
import { CoordinatesShape } from './Coordinates';

const MapGeometry = {
  type: PropTypes.string,
  coordinates: PropTypes.arrayOf(CoordinatesShape),
  visible: PropTypes.bool,
};

export const MapGeometryShape = PropTypes.shape(MapGeometry);
export const MapGeometryExact = PropTypes.exact(MapGeometry);
